import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Cuenta/cuenta';
import CuentaGrid from './EnfermeriaGrid';

const mstp = state => {
    return {...state.cuenta}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(CuentaGrid)
